
import React, { useState, useEffect } from 'react';

export const useCountUp = (ref: React.RefObject<HTMLElement | null>, end: number, duration: number = 2000) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        let frameId: number;
        const element = ref.current;
        if (!element) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    let startTimestamp: number | null = null;
                    const step = (timestamp: number) => {
                        if (!startTimestamp) startTimestamp = timestamp;
                        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
                        const newCount = Math.floor(progress * end);
                        setCount(newCount);
                        if (progress < 1) {
                            frameId = requestAnimationFrame(step);
                        } else {
                            setCount(end);
                        }
                    };
                    frameId = requestAnimationFrame(step);
                    observer.unobserve(element);
                }
            },
            { threshold: 0.5 }
        );

        observer.observe(element);

        return () => {
            if (frameId) {
              cancelAnimationFrame(frameId);
            }
            if (element) {
                observer.unobserve(element);
            }
        };
    }, [ref, end, duration]);

    return count;
};
